import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { BackToPlannerHelper } from '../../../components/back_to_planner/helpers/back_to_planner_helper';
import { IApplicationConfiguration } from '../../../interfaces/scheduler_interfaces';
import { TSaveCoReqCourseToTermAP1Command } from './save_coreq_course_to_term_ap1_command';
import { TSaveCoReqCourseToTermAP3Command } from './save_coreq_course_to_term_ap3_command';

export type TSaveCoReqCourseToTermCommand = (courseId: number, termId: number, slotId: number) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'saveCoReqCourseToTermCommand',
    (
      defineCommand: IDefineCommand,
      saveCoReqCourseToTermAP1Command: TSaveCoReqCourseToTermAP1Command,
      saveCoReqCourseToTermAP3Command: TSaveCoReqCourseToTermAP3Command,
      ngBackToPlannerHelper: BackToPlannerHelper
    ): ICommand => {
      return defineCommand(
        'saveCoReqCourseToTermCommand',
        (deferred, courseId: number, termId: number, slotId: number) => {
          const isAP1Enabled = ngBackToPlannerHelper.isAP1PlannerEnabled();

          if (isAP1Enabled) {
            return saveCoReqCourseToTermAP1Command(courseId, termId, slotId).then(deferred.resolve);
          }

          return saveCoReqCourseToTermAP3Command(courseId, termId).then(deferred.resolve);
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/commands/save_coreq_course_to_term_command.ts